module.exports = __webpack_public_path__ + "static/wind-sand-and-stars-393fa5fbc4802742cccd2833dde3aa2b.jpg";